import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "crossoverFilled"
const CrossoverFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M14.45 15.75 8.539 21.663 7.212 20.337 10.862 16.687H2.25V14.813H10.862L7.212 11.163 8.538 9.838zM16.788 3.663 13.138 7.313H21.75V9.188H13.138L16.788 12.838 15.462 14.162 9.55 8.25 15.462 2.337z" />
        </svg>
      }
    </span>
  )
}
export default CrossoverFilledIcon
